/**
 * 管理端接口根路径。
 * 环境变量仅配置路径（默认 /admin-api），不写死域名；
 * 实际请求随当前页面 origin 走（本地 / 线上一致）。
 */
const RAW = (process.env.VUE_APP_BASE_API || '/admin-api').trim()

/** 相对路径，如 /admin-api；若配置了完整 URL 则原样返回 */
export function getApiPath () {
  if (/^https?:\/\//i.test(RAW)) {
    return RAW.replace(/\/$/, '')
  }
  return RAW.startsWith('/') ? RAW : '/' + RAW
}

/**
 * 绝对接口根地址 = 当前页面地址 origin + 接口路径。
 * 例：页面 http://192.168.1.10/ → http://192.168.1.10/admin-api
 */
export function getApiBaseUrl () {
  const path = getApiPath()
  if (/^https?:\/\//i.test(path)) {
    return path
  }
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin.replace(/\/$/, '') + path
  }
  return path
}
